import transformRequest from './helpers/transform';

/**
 * This transform Layer is used by airports consumer
 * */

/**
 * This method return a Request object after delete unnecesary paramter
 * @param {*} request Request Object pass to client request API axios at this moment
 */
const transformRequestAirport = (request) => {
  // params to delete don't matter the value store
  const paramsDelete = [
    'airlineIataCode',
    'labelStructure',
    'filterOriginAirportsByMarket',
    'filterByMarket'
  ];

  const cleanRequest = transformRequest(request, paramsDelete);

  return cleanRequest;
};

export default transformRequestAirport;
